import * as React from "react"
import SubscriptionForm from "../components/subscription-form"

const Footer = () => {
  return (
    <React.Fragment>
      <div className="px-4 md:px-0 my-8">
        <SubscriptionForm />
      </div>

      <div className="border-t border-red-100 py-6 px-4 md:px-0">
        <div className="flex px-4 lg:px-0">
          <div className="flex-1">
            Created by {' '}
            <a href="https://twitter.com/aribsummer" className="text-red-500 hover:underline hover:text-red-600">
              Ari Summer
            </a>
          </div>

          <div className="space-x-4">
            <a href="https://twitter.com/aribsummer" className="text-red-500 hover:underline hover:text-red-600">
              Twitter
            </a>

            <a href="mailto:ari@arisummer.com" className="text-red-500 hover:underline hover:text-red-600">
              Contact me
            </a>
          </div>
        </div>
      </div>
    </React.Fragment>
  )
}

export default Footer
